export default __webpack_public_path__ + "static/media/cont3.af008cc4.jpg";